import { useTranslation } from 'react-i18next';

export type BetMode = 'manual' | 'auto';

interface Props {
  mode: BetMode;
  onChange: (m: BetMode) => void;
  disabled?: boolean;
}

export function ModeTabs({ mode, onChange, disabled }: Props) {
  const { t } = useTranslation('originals');
  const tabs: BetMode[] = ['manual', 'auto'];
  return (
    <div className="flex gap-1.5 p-1 rounded-xl bg-[var(--bg-sunken)] border border-[var(--border)]">
      {tabs.map((m) => (
        <button
          key={m}
          type="button"
          disabled={disabled}
          aria-pressed={mode === m}
          onClick={() => onChange(m)}
          className={[
            'flex-1 h-11 rounded-lg text-[14px] font-bold transition-all disabled:opacity-40',
            mode === m
              ? 'bg-[var(--bg-elevated)] text-[var(--text-primary)] shadow-[0_2px_8px_rgba(0,0,0,0.3)]'
              : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]',
          ].join(' ')}
        >
          {t(`panel.${m}`)}
        </button>
      ))}
    </div>
  );
}
